import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const demoApi = axios.create({ baseURL: `${BASE}/api/demo` });

export async function getDemoStats() {
    const r = await demoApi.get("/stats");
    return r.data;
}
export async function startDemo() {
    const r = await demoApi.post("/start");
    return r.data;
}
export async function askDemo(payload) {
    const r = await demoApi.post("/ask", payload);
    return r.data;
}
export async function submitLead(payload) {
    const r = await demoApi.post("/lead", payload);
    return r.data;
}
export async function getDemoMoneyMeter() {
    const r = await demoApi.get("/money-meter");
    return r.data;
}
export async function simulateDemoMoneyMeter(deltas) {
    const r = await demoApi.post("/money-meter/simulate", { deltas });
    return r.data;
}
export async function scanDemo(payload) {
    const r = await demoApi.post("/scan", payload);
    return r.data;
}
